<!--手机端联系方式-->

<template>
  <div>
    <!--logo-->
    <div class='logo'>
      <img src='../../assets/images/logo.png'>
    </div>
    <template>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="首页" name="homePage">
          <div class='content'>
            <!--标题-->
            <h2>联系我们</h2>
            <h4>广东埃文低碳科技股份有限公司</h4>

            <!--联系详情-->
            <div class='contactDetails'>
              <div>
                <p>地址:</p> <span>{{ this.tableData.address }}</span>
              </div>
              <div>
                <p>电话:</p> <span>{{ this.tableData.phone }}</span>
              </div>
              <div>
                <p>邮箱:</p> <span>{{ this.tableData.email }}</span>
              </div>
              <div>
                <p>商务合作:</p> <span>郭先生 19328700223</span>
              </div>
              <div>
                <p>培训洽谈:</p> <span>龙秘书长 13760662545</span>
              </div>
            </div>

            <!--二维码-->
            <div class='QR'>
              <ul>
                <li>
                  <div class="block" v-for="fit in fits" :key="fit">
                    <el-image
                      v-if='tableData.uploadImgAbsolutePath != null'
                      :src='imageUrl'
                      alt='logo'
                      :preview-src-list='imageList1'
                      :fit="fit"></el-image>
                  </div>
                  <p>低碳知识及新闻埃文官方公众号</p>
                </li>
                <li>
                  <div class="block" v-for="fit in fits" :key="fit">
                    <el-image
                      v-if='tableData.uploadImgAbsolutePath1 != null'
                      :src='imageUrl1'
                      alt='logo'
                      :preview-src-list='imageList2'
                      :fit="fit"></el-image>
                  </div>
                  <p>学习低碳小知识关注官方抖音号</p>
                </li>
              </ul>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="主营业务" name="mainBusiness">
        </el-tab-pane>
        <el-tab-pane label="经典案例" name="case"></el-tab-pane>
        <el-tab-pane label="新闻中心" name="newsCenter"></el-tab-pane>
        <el-tab-pane label="研究院" name="researchInstitute"></el-tab-pane>
        <el-tab-pane label="关于埃文" name="avi">
        </el-tab-pane>
      </el-tabs>
      <!--底部占位-->
      <div style='height: 80px;'>
      </div>
    </template>
    <!--底部选项卡-->
    <div class='bottom'>
      <ul>
        <li class='tab' @click="tabButton(1)">联系方式</li>
        <li class='tab' @click="tabButton(2)">加入低碳行业</li>
        <li class='tab' @click="tabButton(3)">合作网站</li>
      </ul>
      <p>企业节能减排与低碳发展综合解决方案提供商</p>
    </div>
  </div>
</template>
<script>
import { selectConfig } from '@api/auth'

export default {
  data () {
    return {
      queryParams: {},
      // img图片
      fits: ['fill'],
      activeName: 'homePage',
      fit: 'fill', // 想要什么属性就在这个位置设置什么属性
      tableData: {
        legacyPortal: '',
        address: '',
        phone: '',
        fax: '',
        email: '',
        imageUrl: '',
        dyImageUrl: '',
        filings: '',
        numberTrainees: '',
        numberCooperation: '',
        serviceAmount: '',
        uploadImgAbsolutePath: '',
        uploadImgAbsolutePath1: ''
      },
      imageList1: [],
      imageUrl: '',
      imageList2: [],
      imageUrl1: '',
      url: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
      // 单选框
      radio: '1'
    }
  },
  methods: {
    tabButton (raw) {
      if (raw === 1) {
        // 联系方式
        this.$router.push({
          path: '/mobileContacInformation',
          query: {}
        })
      } else if (raw === 2) {
        // 加入低碳
        this.$router.push({
          path: '/moblielowCarbonIndustry',
          query: {}
        })
      } else if (raw === 3) {
        // 合作伙伴
        this.$router.push({
          path: '/mobileCooperativePartner',
          query: {}
        })
      }
    },
    handleClick (tab, event) {
      if (tab.name === 'homePage') {
        this.$router.push({
          path: '/mobileIndex',
          query: {
          }
        })
      } else if (tab.name === 'mainBusiness') {
        this.$router.push({
          path: '/mobileMainBusiness',
          query: {
          }
        })
      } else if (tab.name === 'case') {
        this.$router.push({
          path: '/mobileCase',
          query: {
          }
        })
      } else if (tab.name === 'researchInstitute') {
        this.$router.push({
          path: '/mobileResearchInstituter',
          query: {
          }
        })
      } else if (tab.name === 'avi') {
        this.$router.push({
          path: '/mobileAboutAvi',
          query: {
          }
        })
      } else if (tab.name === 'newsCenter') {
        this.$router.push({
          path: '/mobileNewsCenter',
          query: {
          }
        })
      }
    },

    /** 查询网站配置 */
    webConfig () {
      let that = this
      selectConfig(this.queryParams).then(res => {
        that.tableData.address = res.address
        that.tableData.phone = res.phone
        that.tableData.fax = res.fax
        that.tableData.email = res.email
        that.tableData.imageUrl = res.imageUrl
        that.tableData.dyImageUrl = res.dyImageUrl
        that.tableData.filings = res.filings
        that.tableData.legacyPortal = res.legacyPortal
        that.tableData.numberTrainees = res.numberTrainees
        that.tableData.numberCooperation = res.numberCooperation
        that.tableData.serviceAmount = res.serviceAmount
        that.tableData.uploadImgAbsolutePath = res.imageUrl
        that.tableData.uploadImgAbsolutePath1 = res.dyImageUrl

        if (this.tableData.uploadImgAbsolutePath != null) {
          this.imageUrl = this.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(this.tableData.uploadImgAbsolutePath)
        }
        this.imageList1 = []
        if (this.tableData.uploadImgAbsolutePath != null) {
          this.imageList1.push(this.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(this.tableData.uploadImgAbsolutePath))
        }
        if (this.tableData.uploadImgAbsolutePath1 != null) {
          this.imageUrl1 = this.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(this.tableData.uploadImgAbsolutePath1)
        }
        this.imageList2 = []
        if (this.tableData.uploadImgAbsolutePath1 != null) {
          this.imageList2.push(this.$baseUrl + '/upload/loadFileStreamByPath?path=' + encodeURIComponent(this.tableData.uploadImgAbsolutePath1))
        }
      })
    }
  },
  created () {
    this.webConfig()
  },
  activated () {
  }
}
</script>

<style lang="less" scoped>
.content{
  width: 80%;
  margin: 20px auto;
  h2{
    text-align: center;
    margin-bottom: 20px;
    color: #333;
  }
  h4{
    text-align: center;
    margin-bottom: 20px;
    color: #333;
  }

  //联系详情
  .contactDetails{
    div{
      min-height: 25px;
      margin-bottom: 12px;
      color: #333;
    }
    p{
      float: left;
      height: 25px;
      font-weight: bold;
      font-size: 14px;
      margin-right: 8px;
    }
    span{
      font-size: 14px;
    }
  }

  //二维码
  .QR{
    margin-top: 50px;
    li{
      width: 50%;
      float: left;
      .block{
        width: 120px;
        height: 120px;
        margin: 0 auto 8px;
      }
     p{
       width:120px;
       margin: 0 auto;
       color: #000;
       font-size: 12px;
     }
    }
  }
}
.el-row {
  &:last-child {
    margin-bottom: 0;
  }
}

//logo
.logo{
  img{
    width: 70%;
    display: block;
    margin:10px auto;
  }
}

//tabs样式
::v-deep .el-tabs__item {
  border: 1px solid #fff;
  background-color: #90bc4f;
  width: 33.33%;
  font-size: 14px;
  color: #fff;
  height: 40px;
  line-height: 40px;
  float: left;
  display: block;
  text-align: center;
}
::v-deep .el-tabs__item.is-top:nth-child(2) {
  padding-left: 20px;
}
::v-deep .el-tabs__item.is-top:nth-child(7) {
  padding-left: 0px;
}
//底部选项卡
.bottom{
  background-color: #fff;
  height: 80px;
  width: 100%;
  position: fixed;
  bottom: 0;
  .tab{
    width: 33.33%;
    float: left;
    text-align: center;
    background-color: #90bc4f;
    border: 1px solid #fff;
    font-size: 14px;
    color: #fff;
    height: 40px;
    line-height: 40px;
  }
  p{
    font-size: 14px;
    text-align: center;
    height: 40px;
    line-height: 40px;
    color:#90bc4f;
  }
}
::v-deep .el-tab-pane{
  height:620px;
}
///去掉tab下划线
::v-deep .el-tabs__active-bar {
  width: 0px !important;
}
</style>
